import axios from 'axios';
import {TerminalDocument} from '@/models/terminal.model';

export async function addTerminal(data: Partial<TerminalDocument>): Promise<TerminalDocument | null> {
  try {
    const result = await axios.post('/term/add', data)
    return result ? result.data : null
  } catch (e) {
    return null
  }
}

export async function updateTerminal(termId: string, data: Partial<TerminalDocument>): Promise<TerminalDocument | null> {
  try {
    const result = await axios.put(`/term/${termId}`, data)
    return result ? result.data : null
  } catch (e) {
    return null
  }
}

export async function removeTerminal(termId: string): Promise<boolean> {
  try {
    const result = await axios.delete(`/term/${termId}`)
    return result && result.status === 200
  } catch (e) {
    return false
  }
}

export async function fetchTerminals(prjId: string): Promise<TerminalDocument[]> {
  try {
    const result = await axios.get(`/term/all/${prjId}`)
    return result ? result.data : []
  } catch (e) {
    return []
  }
}
